import { Outlet } from "react-router-dom";
import { ListingComponentProvider } from "../../components/common/listingComponents/ListingComponentContext";
import { GET_SURVEYS } from "../../graphql/queries/getSurveys";
// Reuses the shared GET_SURVEYS query (also used by useSurveyData). Its records are aliased to
// `items` so the listing provider can paginate them. Empty initial filter => backend returns all
// surveys for the current program scope.
const SurveyManagementOutlet = () => (
  <ListingComponentProvider
    query={GET_SURVEYS}
    queryKey="getSurveyDefinitions"
    initialFilterData={{}}
  >
    <Outlet />
  </ListingComponentProvider>
);

export default SurveyManagementOutlet;
